<i18n>
{
	"en": {
		"title": "Edit Preferred Vendor",
		"save": "Save"
	},
	"no": {
		"title": "Edit Preferred Vendor",
		"save": "Lagre"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:title="$t('title')"
		icon="order"
		iconColor="blue"
		@close="$emit('close')"
		@ok="save"
		@shown="processShown"
	>
		<div class="dialog-mid">
			<VendorSelect
				:selectedItems="vendors"
				style="margin-bottom: 5px"
				@change="addVendor"
			/>
			<draggable
				v-model="vendors"
				v-bind="dragOptions"
				@start="dragging=true"
				@end="dragging=false"
			>
				<transition-group type="transition" :name="!dragging ? 'flip-list' : null" style="flex-direction: row">
					<t-tag
						v-for="(item, index) in vendors"
						:key="item.id"
						style="margin: 3px 0px; cursor: move!important"
						@remove="onRemoveTag(item)"
					>
						{{ index+1 }}. {{ item.name }}
					</t-tag>
				</transition-group>
			</draggable>
		</div>
	</t-dialog>
</template>
<script>
import VendorSelect from '@/modules/vendors/VendorSelect.vue';

import draggable from 'vuedraggable';

export default {
	name: 'PreferredVendorsDialog',
	components: { draggable, VendorSelect },
	props: {
		isShown: Boolean,
		preferredVendor: Object,
		carrierVendors: Object
	},
	data() {
		return {
			vendors: [],
			dragging: false
		};
	},
	computed: {
		dragOptions() {
			return {
				animation: 200,
				group: 'name',
				disabled: false,
				ghostClass: 'ghost'
			};
		},
	},
	methods: {
		processShown() {
			this.vendors = [];
			for (let v of this.preferredVendor.vendors) {
				if (this.carrierVendors[v]) this.vendors.push(this.carrierVendors[v]);
			}
		},
		save() {
			this.$emit('ok', this.vendors.map(x => x.id));
		},
		addVendor(v) {
			this.vendors.push(this.carrierVendors[v.id]);
		},
		onRemoveTag(item) {
			let index = this.vendors.indexOf(item);
			this.vendors.splice(index, 1);
		}
	},
};
</script>

<style >
.flip-list-move {
	transition: transform 0.5s;
}
.no-move {
	transition: transform 0s;
}
.ghost {
	opacity: 0.5;
	background: #c8ebfb;
}

</style>

<style lang="scss" scoped>

</style>
